import { get, post, del } from '../httpMethods';
import { ApiResponse, PaginationMeta } from '../../types/api';
import type { PurgePreview, PurgeResult, RetentionUnit } from '../../types/retention';

export interface AuditLog {
  id: string;
  userId?: string;
  /** Login handle of the acting user (resolved by the API). */
  username?: string;
  /** Display name (first + last) of the acting user (resolved by the API). */
  userName?: string;
  module?: string;
  action: string;
  endpoint?: string;
  payload?: any;
  oldValues?: any;
  newValues?: any;
  ipAddress?: string;
  userAgent?: string;
  status?: string;
  message?: string;
  createdAt: string;
}

export const auditService = {
  getAuditLogs: (page = 1, limit = 50, search?: string): Promise<ApiResponse<AuditLog[]> & { meta: PaginationMeta }> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.set('search', search);
    return get<AuditLog[]>(`/audit-logs?${params.toString()}`) as Promise<ApiResponse<AuditLog[]> & { meta: PaginationMeta }>;
  },

  deleteAuditLog: (id: string): Promise<ApiResponse<void>> => {
    return del<void>(`/audit-logs/${id}`);
  },

  bulkDeleteAuditLogs: (ids: string[]): Promise<ApiResponse<{ deleted: string[]; notFound: string[] }>> => {
    return post<{ deleted: string[]; notFound: string[] }>('/audit-logs/bulk-delete', { ids });
  },

  /** How many logs a purge with the given retention window would remove. */
  previewPurgeAuditLogs: (value: number, unit: RetentionUnit): Promise<ApiResponse<PurgePreview>> => {
    return get<PurgePreview>('/audit-logs/purge/preview', { value, unit });
  },

  /** Permanently delete audit logs older than the retention window. */
  purgeAuditLogs: (value: number, unit: RetentionUnit): Promise<ApiResponse<PurgeResult>> => {
    return post<PurgeResult>('/audit-logs/purge', { value, unit });
  },
};
